import React from 'react'
import { Block, Heading, Text } from 'suomifi-ui-components'
import {
  BannerContent,
  PageBanner,
} from 'todistukset-ui/src/vtj/components/landing-page-banner/LandingPageBanner.sc'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

export default function LandingPageBanner(): React.JSX.Element {
  return (
    <PageBanner variant="section" role="region">
      <BannerContent>
        <Heading variant="h1" color="whiteBase">
          <LocalizedString stringKey="todistuksetBannerHeading" />
        </Heading>
        <Block>
          <Text color="whiteBase">
            <LocalizedString
              stringKey={'todistuksetBannerDescriptionWithAet'}
            />
          </Text>
        </Block>
      </BannerContent>
    </PageBanner>
  )
}
